export default class DuplicateSpaceRequest {
  name!: string
  companyDomain?: string | undefined
  spaceId: String = ''
}
